export type Period = "period1" | "period2" | "period3";

export const PERIODS: Period[] = ["period1", "period2", "period3"];

export function formatPeriod(period: Period): string {
  return period === "period1"
    ? "Period 1"
    : period === "period2"
      ? "Period 2"
      : "Period 3";
}

export const PERIOD_OPTIONS = PERIODS.map((period) => ({
  value: period,
  label: formatPeriod(period),
}));
